exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.notification[data-v-36216f29]{\n  width: 80%;\n  margin: auto;\n}\n.box27[data-v-36216f29] {\n    position: relative;\n    margin: 2em 0;\n    padding: 0.5em 1em;\n    border: solid 3px #62c1ce;\n}\n.box27 .box-title[data-v-36216f29] {\n    position: absolute;\n    display: inline-block;\n    top: -27px;\n    left: -3px;\n    padding: 0 9px;\n    height: 25px;\n    line-height: 25px;\n    vertical-align: middle;\n    font-size: 17px;\n    background: #62c1ce;\n    color: #ffffff;\n    font-weight: bold;\n    border-radius: 5px 5px 0 0;\n}\n.box27 p[data-v-36216f29] {\n    margin: 0;\n    padding: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-36216f29","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Mobile/HelpPage/SpHelpPage.vue
// module id = 491
// module chunks = 0